/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespFollowTopButton_itemSearch = {
    readonly displayUriRef: string | null;
    readonly " $refType": "SbRespFollowTopButton_itemSearch";
};
export type SbRespFollowTopButton_itemSearch$data = SbRespFollowTopButton_itemSearch;
export type SbRespFollowTopButton_itemSearch$key = {
    readonly " $data"?: SbRespFollowTopButton_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespFollowTopButton_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespFollowTopButton_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '43ee97ed9defc72907776f59ab758c2e';
export default node;
